import React from "react";
import { Grid, Card, CardContent, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  card: {
    height: "100%",
  },
  title: {
    color: "#666",
    fontSize: 13,
    marginBottom: 8,
  },
  value: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: 1.1,
  },
  subtitle: {
    marginTop: 8,
    fontSize: 12,
    color: "#444",
  },
  highlight: {
    color: "#C47A20",
    fontWeight: 600,
  },
}));

const BudgetKpiCards = ({ cards }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={3} key={card.key}>
          <Card className={classes.card}>
            <CardContent>
              <Typography className={classes.title}>{card.title}</Typography>
              <Typography className={classes.value}>{card.value}</Typography>
              <Typography className={classes.subtitle}>
                {card.subtitleHighlight ? (
                  <span className={classes.highlight}>{card.subtitleHighlight}</span>
                ) : null}
                {card.subtitle}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default BudgetKpiCards;
